import { render } from "./MobileDefaultLayout.vue?vue&type=template&id=e6d52600"
import script from "./MobileDefaultLayout.vue?vue&type=script&lang=js"
export * from "./MobileDefaultLayout.vue?vue&type=script&lang=js"

import "./MobileDefaultLayout.vue?vue&type=style&index=0&id=e6d52600&lang=css"
import "@/styles_mobile/orbit.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../../../../../../../../../private/tmp/codex-user-modern-deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__